export default __webpack_public_path__ + "static/media/11.27717f8d.txt";